export default __webpack_public_path__ + "static/media/logotype_full-color.59cb20bf.svg";